import { data } from '../../svg/LockOpen/data';
import { makeIcon } from '../makeIcon';

export const LockOpen = makeIcon(data, 'lock_open', 'LockOpen');

export default LockOpen;
